import * as z from "zod";
//#region src/models/idParamModel.ts
const idParamModel = z.object({ id: z.string().regex(/^[A-Za-z0-9]{8}$/) });
//#endregion
export { idParamModel };
